module.exports = __webpack_public_path__ + "static/img/DSC02584444.e3f5bab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02584444.jpg
// module id = puP2
// module chunks = 0